import _isArray from 'lodash-es/isArray';

export const appendProperties = (formData: FormData, property, propertyName): FormData => {
  if (typeof property === 'object') {
    if (_isArray(property)) {
      property.forEach(value => {
        formData.append(`${propertyName}[]`, value);
      });
      return formData;
    }
    for (const value in property) {
      if (property.hasOwnProperty(value)) {
        formData = appendProperties(formData, property[value], value);
      }
    }
  } else {
    formData.append(propertyName, property);
  }
  return formData;
};

export const appendFiles = (formData: FormData, files, filesPropertyName: string): FormData => {
  if (Array.isArray(files) && files.length && files[0] instanceof File) {
    for (const file of files) {
      formData.append(`${filesPropertyName}[]`, file, file.name);
    }
  } else if (files instanceof File) {
    formData.append(`${filesPropertyName}`, files, files.name);
  }
  return formData;
};

export const buildFormData = (input: object, filesPropertyName: string): FormData => {
  let formData = new FormData();
  const copiedInput = { ...input };
  const files = copiedInput[filesPropertyName];

  formData = appendFiles(formData, files, filesPropertyName);
  delete copiedInput[filesPropertyName];

  for (const value in copiedInput) {
    if (copiedInput.hasOwnProperty(value)) {
      formData = appendProperties(formData, copiedInput[value], value);
    }
  }
  return formData;
};
